export default "__VITE_ASSET__hI3s5sx0__"